/**
 * Polyfill for String.replaceAll
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll
 * Auto-executes when this module is imported
 */

declare global {
  interface String {
    replaceAll(searchValue: string | RegExp, replaceValue: string | ((substring: string, ...args: any[]) => string)): string;
  }
}

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (search: string | RegExp, replace: string | ((substring: string, ...args: any[]) => string)): string {
    // If search is a string, convert it to a global regex
    if (typeof search === "string") {
      // Escape special regex characters
      const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const regex = new RegExp(escapedSearch, "g");
      if (typeof replace === "string") {
        return this.replace(regex, replace);
      } else {
        return this.replace(regex, replace);
      }
    }
    // If search is a RegExp, it must have the global flag
    if (search instanceof RegExp) {
      if (!search.global) {
        throw new TypeError("String.prototype.replaceAll called with a non-global RegExp argument");
      }
      if (typeof replace === "string") {
        return this.replace(search, replace);
      } else {
        return this.replace(search, replace);
      }
    }
    return String(this);
  };
}

export {};

